/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllocationDto } from '../model';
// @ts-ignore
import type { AllocationStatisticsDto } from '../model';
// @ts-ignore
import type { CreateAllocationsDto } from '../model';
// @ts-ignore
import type { CreateInternalMoveDto } from '../model';
// @ts-ignore
import type { CreateManualAllocationDto } from '../model';
// @ts-ignore
import type { DangerousGoodsValidationDto } from '../model';
// @ts-ignore
import type { InternalMoveResultDto } from '../model';
// @ts-ignore
import type { PreplanningValidationDto } from '../model';
/**
 * AllocationsApi - axios parameter creator
 */
export const AllocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAllocationsDto} [createAllocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreate: async (createAllocationsDto?: CreateAllocationsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateInternalMoveDto} [createInternalMoveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateInternalMoveManual: async (createInternalMoveDto?: CreateInternalMoveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/CreateInternalMoveManual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInternalMoveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateManualAllocationDto} [createManualAllocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateManual: async (createManualAllocationDto?: CreateManualAllocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/CreateManual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualAllocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateManualAllocationDto} [createManualAllocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateManualForSingleTurnover: async (createManualAllocationDto?: CreateManualAllocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/CreateManualForSingleTurnover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualAllocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DangerousGoodsValidationDto} [dangerousGoodsValidationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsDangerousGoodsValidation: async (dangerousGoodsValidationDto?: DangerousGoodsValidationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/DangerousGoodsValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dangerousGoodsValidationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsGetAllocationStatistics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/GetAllocationStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreplanningValidationDto} [preplanningValidationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsPrePlanningValidation: async (preplanningValidationDto?: PreplanningValidationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/PrePlanningValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preplanningValidationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [inboundOrderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsValidateAllocationCapacity: async (inboundOrderIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/Allocations/ValidateAllocationCapacity/ValidateAllocationCapacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (inboundOrderIds) {
                localVarQueryParameter['InboundOrderIds'] = inboundOrderIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationsApi - functional programming interface
 */
export const AllocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAllocationsDto} [createAllocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsCreate(createAllocationsDto?: CreateAllocationsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsCreate(createAllocationsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateInternalMoveDto} [createInternalMoveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsCreateInternalMoveManual(createInternalMoveDto?: CreateInternalMoveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalMoveResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsCreateInternalMoveManual(createInternalMoveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsCreateInternalMoveManual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateManualAllocationDto} [createManualAllocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsCreateManual(createManualAllocationDto?: CreateManualAllocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsCreateManual(createManualAllocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsCreateManual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateManualAllocationDto} [createManualAllocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsCreateManualForSingleTurnover(createManualAllocationDto?: CreateManualAllocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsCreateManualForSingleTurnover(createManualAllocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsCreateManualForSingleTurnover']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DangerousGoodsValidationDto} [dangerousGoodsValidationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsDangerousGoodsValidation(dangerousGoodsValidationDto?: DangerousGoodsValidationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsDangerousGoodsValidation(dangerousGoodsValidationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsDangerousGoodsValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsGetAllocationStatistics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AllocationStatisticsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsGetAllocationStatistics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsGetAllocationStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PreplanningValidationDto} [preplanningValidationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsPrePlanningValidation(preplanningValidationDto?: PreplanningValidationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsPrePlanningValidation(preplanningValidationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsPrePlanningValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [inboundOrderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationsValidateAllocationCapacity(inboundOrderIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationsValidateAllocationCapacity(inboundOrderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationsApi.allocationsValidateAllocationCapacity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationsApi - factory interface
 */
export const AllocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {AllocationsApiAllocationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreate(requestParameters: AllocationsApiAllocationsCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationDto> {
            return localVarFp.allocationsCreate(requestParameters.createAllocationsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsCreateInternalMoveManualRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateInternalMoveManual(requestParameters: AllocationsApiAllocationsCreateInternalMoveManualRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InternalMoveResultDto> {
            return localVarFp.allocationsCreateInternalMoveManual(requestParameters.createInternalMoveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsCreateManualRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateManual(requestParameters: AllocationsApiAllocationsCreateManualRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationDto> {
            return localVarFp.allocationsCreateManual(requestParameters.createManualAllocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsCreateManualForSingleTurnoverRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsCreateManualForSingleTurnover(requestParameters: AllocationsApiAllocationsCreateManualForSingleTurnoverRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationDto> {
            return localVarFp.allocationsCreateManualForSingleTurnover(requestParameters.createManualAllocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsDangerousGoodsValidationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsDangerousGoodsValidation(requestParameters: AllocationsApiAllocationsDangerousGoodsValidationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.allocationsDangerousGoodsValidation(requestParameters.dangerousGoodsValidationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsGetAllocationStatistics(options?: RawAxiosRequestConfig): AxiosPromise<Array<AllocationStatisticsDto>> {
            return localVarFp.allocationsGetAllocationStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsPrePlanningValidationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsPrePlanningValidation(requestParameters: AllocationsApiAllocationsPrePlanningValidationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.allocationsPrePlanningValidation(requestParameters.preplanningValidationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationsApiAllocationsValidateAllocationCapacityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationsValidateAllocationCapacity(requestParameters: AllocationsApiAllocationsValidateAllocationCapacityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.allocationsValidateAllocationCapacity(requestParameters.inboundOrderIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for allocationsCreate operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsCreateRequest {
    readonly createAllocationsDto?: CreateAllocationsDto
}

/**
 * Request parameters for allocationsCreateInternalMoveManual operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsCreateInternalMoveManualRequest {
    readonly createInternalMoveDto?: CreateInternalMoveDto
}

/**
 * Request parameters for allocationsCreateManual operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsCreateManualRequest {
    readonly createManualAllocationDto?: CreateManualAllocationDto
}

/**
 * Request parameters for allocationsCreateManualForSingleTurnover operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsCreateManualForSingleTurnoverRequest {
    readonly createManualAllocationDto?: CreateManualAllocationDto
}

/**
 * Request parameters for allocationsDangerousGoodsValidation operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsDangerousGoodsValidationRequest {
    readonly dangerousGoodsValidationDto?: DangerousGoodsValidationDto
}

/**
 * Request parameters for allocationsPrePlanningValidation operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsPrePlanningValidationRequest {
    readonly preplanningValidationDto?: PreplanningValidationDto
}

/**
 * Request parameters for allocationsValidateAllocationCapacity operation in AllocationsApi.
 */
export interface AllocationsApiAllocationsValidateAllocationCapacityRequest {
    readonly inboundOrderIds?: Array<number>
}

/**
 * AllocationsApi - object-oriented interface
 */
export class AllocationsApi extends BaseAPI {
    /**
     * 
     * @param {AllocationsApiAllocationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsCreate(requestParameters: AllocationsApiAllocationsCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsCreate(requestParameters.createAllocationsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsCreateInternalMoveManualRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsCreateInternalMoveManual(requestParameters: AllocationsApiAllocationsCreateInternalMoveManualRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsCreateInternalMoveManual(requestParameters.createInternalMoveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsCreateManualRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsCreateManual(requestParameters: AllocationsApiAllocationsCreateManualRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsCreateManual(requestParameters.createManualAllocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsCreateManualForSingleTurnoverRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsCreateManualForSingleTurnover(requestParameters: AllocationsApiAllocationsCreateManualForSingleTurnoverRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsCreateManualForSingleTurnover(requestParameters.createManualAllocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsDangerousGoodsValidationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsDangerousGoodsValidation(requestParameters: AllocationsApiAllocationsDangerousGoodsValidationRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsDangerousGoodsValidation(requestParameters.dangerousGoodsValidationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsGetAllocationStatistics(options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsGetAllocationStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsPrePlanningValidationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsPrePlanningValidation(requestParameters: AllocationsApiAllocationsPrePlanningValidationRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsPrePlanningValidation(requestParameters.preplanningValidationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationsApiAllocationsValidateAllocationCapacityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationsValidateAllocationCapacity(requestParameters: AllocationsApiAllocationsValidateAllocationCapacityRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationsApiFp(this.configuration).allocationsValidateAllocationCapacity(requestParameters.inboundOrderIds, options).then((request) => request(this.axios, this.basePath));
    }
}

